<!-- create a div with class column -->
<div class="columns">
    <div>
        <button class="btn" mat-raised-button color="accent" (click)="create()" > Create Presentation </button>
    </div>
</div>
